export default __webpack_public_path__ + "static/media/network_error.fcc6d4be.png";